import { createFileRoute } from '@tanstack/react-router';
import { AuditsList } from '@/app/(client)/audits/-components/AuditsList';

export const Route = createFileRoute(
  '/(client)/audits/(pages)/(list)/audits-for-company/archive/',
)({
  component: ArchiveAuditsForCompanyPage,
});

function ArchiveAuditsForCompanyPage() {
  return <AuditsList activeTab='audits-for-me' isArchived={true} />;
}
